import { render, staticRenderFns } from "./CouponActivate.vue?vue&type=template&id=6cc9c614&"
import script from "./CouponActivate.vue?vue&type=script&lang=js&"
export * from "./CouponActivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports